export type AccessRequestStatus = 'pending' | 'approved' | 'rejected' | 'cancelled';

export interface AccessRequest {
    id: string;
    organizationId: string;
    hotelId: number;
    hotelName: string;
    dataSource: string;
    requesterUserId: string;
    requesterName: string;
    requesterEmail: string;
    adminUserId?: number;
    adminName?: string;
    adminEmail?: string;
    adminRole?: string;
    note?: string;
    status: AccessRequestStatus;
    createdAt: number;
    updatedAt: number;
    resolvedAt?: number;
    resolvedByUserId?: number;
    resolvedByName?: string;
}

export interface AccessRequestAdmin {
    userId: number;
    name: string;
    email: string;
    role: string;
}

export interface CreateAccessRequestContract {
    hotelId: number;
    hotelName: string;
    note?: string;
    items: { dataSource: string; admin?: AccessRequestAdmin }[];
}

export interface PropertyAdmin {
    userId: number;
    name: string;
    email: string;
    role: string;
    dataSources: string[];
}

// Accepts both the app's role keys and the uppercase names suggested on JSB-3200.
const PROPERTY_ADMIN_ROLES: Record<string, { label: string; order: number }> = {
    'property-admin': { label: 'Property admin', order: 0 },
    HOTEL_ADMIN: { label: 'Property admin', order: 0 },
    'org-owner': { label: 'Owner', order: 1 },
    OWNER: { label: 'Owner', order: 1 },
    ORGANISATION_OWNER: { label: 'Owner', order: 1 },
    'org-admin': { label: 'Organisation admin', order: 2 },
    ORGANISATION_ADMIN: { label: 'Organisation admin', order: 2 },
};

export function getPropertyAdminRoleLabel(role: string): string {
    return PROPERTY_ADMIN_ROLES[role]?.label ?? role;
}

export function comparePropertyAdmins(a: PropertyAdmin, b: PropertyAdmin): number {
    return (PROPERTY_ADMIN_ROLES[a.role]?.order ?? 99) - (PROPERTY_ADMIN_ROLES[b.role]?.order ?? 99);
}
